
import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BackButton from "../../components/BackButton";
import { Container, Row, Col } from "react-bootstrap";
import "../../css/Filming.css";
import { useLocation } from "react-router-dom";

// Đường dẫn JSON phim phóng sự cưới trên GitHub
const ALBUM_JSON_URL =
    "https://raw.githubusercontent.com/VuongMinh01/MinMedia-anh/main/SanPhamQuayChup/PhimPSC.json";

// Chuẩn hóa URL
const normalizeUrl = (url) => {
    if (typeof url !== "string") return "";

    const value = url.trim();

    if (!value) return "";

    return /^https?:\/\//i.test(value)
        ? value
        : `https://${value}`;
};

export default function PhimPhongSuCuoi() {
    const location = useLocation();

    const [albums, setAlbums] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    // Cuộn lên đầu khi chuyển đường dẫn
    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "auto",
        });
    }, [location.pathname]);

    // Tải danh sách phim từ JSON
    useEffect(() => {
        let isMounted = true;

        const fetchAlbums = async () => {
            try {
                setLoading(true);
                setError("");

                const response = await fetch(ALBUM_JSON_URL);

                if (!response.ok) {
                    throw new Error(
                        `Không thể tải JSON (HTTP ${response.status})`
                    );
                }

                const data = await response.json();

                if (!Array.isArray(data)) {
                    throw new Error(
                        "File JSON phải chứa một danh sách phim."
                    );
                }

                const validAlbums = data
                    .filter(
                        (item) =>
                            item &&
                            typeof item.title === "string" &&
                            item.title.trim() !== "" &&
                            typeof item.url === "string" &&
                            item.url.trim() !== ""
                    )
                    .map((item) => ({
                        title: item.title.trim(),
                        url: normalizeUrl(item.url),
                    }))
                    .filter((item) => {
                        try {
                            const parsedUrl = new URL(item.url);

                            return (
                                parsedUrl.protocol === "https:" ||
                                parsedUrl.protocol === "http:"
                            );
                        } catch {
                            return false;
                        }
                    });

                if (isMounted) {
                    setAlbums(validAlbums);
                }
            } catch (err) {
                console.error("Lỗi tải phim phóng sự cưới:", err);

                if (isMounted) {
                    setError(
                        "Không thể tải danh sách phim. Vui lòng kiểm tra file JSON trên GitHub."
                    );
                }
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        fetchAlbums();

        return () => {
            isMounted = false;
        };
    }, []);

    // Chia thành các hàng, tối đa 4 phim mỗi hàng
    const albumRows = Array.from(
        { length: Math.ceil(albums.length / 4) },
        (_, index) => albums.slice(index * 4, index * 4 + 4)
    );

    return (
        <Container fluid>


            <Container className="album-list-page">
                <div className="page-back">
                    <BackButton fallback="/" />
                </div>

                <div className="album-page-title">
                    <h1>Phim Phóng Sự Cưới</h1>
                    <p>Chọn phim bạn muốn xem</p>
                </div>

                {loading && (
                    <p className="album-message">
                        Đang tải danh sách phim...
                    </p>
                )}

                {!loading && error && (
                    <p className="album-error">{error}</p>
                )}

                {!loading && !error && albums.length === 0 && (
                    <p className="album-message">
                        Hiện chưa có phim nào.
                    </p>
                )}

                {!loading &&
                    !error &&
                    albumRows.map((rowAlbums, rowIndex) => (
                        <Row
                            className="service-filming-inform"
                            key={rowIndex}
                        >
                            {rowAlbums.map((album, index) => (
                                <Col
                                    xs={6}
                                    sm={3}
                                    key={`${album.title}-${index}`}
                                >
                                    <a
                                        className="NavLink"
                                        href={album.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {album.title}
                                    </a>
                                </Col>
                            ))}
                        </Row>
                    ))}
            </Container>

            <Footer />
        </Container>
    );
}
